export default {
  title_one: '🥳 {{offer}} aplicată',
  title_few: '🥳 {{count}} oferte aplicate',
  title_other: '🥳 {{count}} oferte aplicate',
};
